<div class="score-sheet" *ngIf="game; else loading">
  <header class="score-sheet__header">
    <h1>Scoresheet</h1>
    <div class="score-sheet__controls">
      <mat-slide-toggle [(ngModel)]="showBench" name="showBench">Show bench</mat-slide-toggle>
    </div>
    <table class="score-sheet__boxscore">
      <thead>
      <tr>
        <th></th>
        <th *ngFor="let inning of boxscoreInnings">{{ inning }}</th>
        <th class="score-sheet__boxscore-total">R</th>
        <th class="score-sheet__boxscore-total">H</th>
        <th class="score-sheet__boxscore-total">E</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th class="score-sheet__boxscore-team">{{ awayName }}</th>
        <td *ngFor="let inning of boxscoreInnings">
          {{ game.away?.scoreBoard?.[inning - 1] ?? '' }}
        </td>
        <td class="score-sheet__boxscore-total">{{ game.away?.runs ?? 0 }}</td>
        <td class="score-sheet__boxscore-total">{{ game.away?.hits ?? 0 }}</td>
        <td class="score-sheet__boxscore-total">{{ game.away?.errors ?? 0 }}</td>
      </tr>
      <tr>
        <th class="score-sheet__boxscore-team">{{ homeName }}</th>
        <td *ngFor="let inning of boxscoreInnings">
          {{ game.home?.scoreBoard?.[inning - 1] ?? '' }}
        </td>
        <td class="score-sheet__boxscore-total">{{ game.home?.runs ?? 0 }}</td>
        <td class="score-sheet__boxscore-total">{{ game.home?.hits ?? 0 }}</td>
        <td class="score-sheet__boxscore-total">{{ game.home?.errors ?? 0 }}</td>
      </tr>
      </tbody>
    </table>
  </header>

  <section class="score-sheet__team">
    <div class="score-sheet__pair">
      <div class="score-sheet__offense">
        <app-offense [lineup]="game.away?.lineup" [broadcast]="broadcast"
                     [currentBatter]="game.currentBatter"
                     [opposingPitchers]="game.home?.pitchers"
                     [teamName]="awayName"
                     [team]="game.away"
                     [showBench]="showBench"></app-offense>
      </div>
      <aside class="score-sheet__defense" [class.score-sheet__defense--with-bench]="showBench">
        <app-defense [team]="game.home" [broadcast]="broadcast" [teamName]="homeName"
                     [bench]="showBench ? benchFor(game.home) : null"></app-defense>
        <app-pitchers [pitchers]="game.home?.pitchers" [broadcast]="broadcast"></app-pitchers>
      </aside>
    </div>
  </section>

  <section class="score-sheet__team">
    <div class="score-sheet__pair">
      <div class="score-sheet__offense">
        <app-offense [lineup]="game.home?.lineup" [broadcast]="broadcast"
                     [currentBatter]="game.currentBatter"
                     [opposingPitchers]="game.away?.pitchers"
                     [teamName]="homeName"
                     [team]="game.home"
                     [showBench]="showBench"></app-offense>
      </div>
      <aside class="score-sheet__defense" [class.score-sheet__defense--with-bench]="showBench">
        <app-defense [team]="game.away" [broadcast]="broadcast" [teamName]="awayName"
                     [bench]="showBench ? benchFor(game.away) : null"></app-defense>
        <app-pitchers [pitchers]="game.away?.pitchers" [broadcast]="broadcast"></app-pitchers>
      </aside>
    </div>
  </section>
</div>

<ng-template #loading>
  <div class="score-sheet__loading">Loading scoresheet…</div>
</ng-template>
